import i18next, { t } from 'i18next'
import React from 'react'
import { Link } from 'react-router-dom'
import { Action, mk_widget, Widget } from 'widgets-for-react'
import { decodeHTMLEntities, gtmPush, toRelativeUrl } from '../../../helpers'
import { HeaderState, OptionsState } from '../../public_site.main.mod'
import { WordPress } from '../../wordpress/wordpress_api'
import MainNavItems from './nav_items_main'
import { SearchBar } from './searchbar'

export const header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>> = (
  props,
  opts
) =>
  mk_widget({
    run: setState => {
      const currentLanguage = window.wp.language;
      const languageArray = [
        { short: 'en', full: 'International' },
        { short: 'asia', full: "Asia" },
        { short: 'cn', full: "China" },
        { short: 'id', full: "Indonesia" },
        { short: 'be-nl', full: "Belgium [nl]" },
        { short: 'be-fr', full: "Belgium [fr]" },
        { short: 'mx', full: "Mexico" },
        { short: 'nl', full: 'Netherlands' },
        { short: 'ng', full: "Nigeria" },
        { short: 'pk', full: "Pakistan"}
      ];

      return (
        <Header
          className="site-header sh"
          onMouseLeave={_ => setState(s => ({ ...s, hoveredItem: null }))}
        >
          <div className="sh__disclaimer typo--s ff--primary">
            <span>{ i18next.t('general.disclaimer')}</span>
          </div>
          <div className="sh__inner container container--m gutter--m">
            <Link className="sh__logo-link" to={window.wp.language == 'nl' ? '/nl' : '/'}>
              <svg className="sh__logo" height={88} width={164} aria-hidden="true"><use xlinkHref="#logo" /></svg>
            </Link>
            <div className="sh__actions">
              <div className="sh__navs">
                <div className="sh__navs-inner">
                  <nav className="sh__nav nav nav--top">
                    <ul className="nav__list">
                      <MainNavItems
                        cssClass="desktop"
                        location="top"
                        hasActiveState={true}
                        hoveredItem={props.hoveredItem}
                        onHoverItem={item => setState(s => ({ ...s, hoveredItem: item }))}
                        onUnhoverItem={() => setState(s => ({ ...s, hoveredItem: null }))}
                      />
                      <li className={`nav__item nav__item--top language lang--${props.lang == "open" ? "open" : "closed"}`}>
                        <a
                          className="nav__link nav__link--top typo--xs lang__switch"
                          onClick={_ => setState(s => ({ ...s, lang: props.lang == "open" ? "closed" : "open" }))}
                        >
                          <span>{'local institutes: '}{languageArray.find(x => x.short == currentLanguage)?.full || 'English'}</span>
                          <svg
                            width="12px"
                            height="6px"
                            aria-hidden="true"
                            className={`lang__icon${props.lang == "open" ? " lang__icon--toggled" : ""}`}
                          >
                            <use xlinkHref="#chevron--down" />
                          </svg>
                        </a>
                        {props.lang == "open" && (
                          <ul className="lang__list">
                            {languageArray.sort((a, b) => a.full.localeCompare(b.full)).map(avLang => (
                              <li className="lang__item">
                                <a className='lang__link typo--xs'
                                  onClick={(_) =>
                                    {
                                      gtmPush({
                                        event: "language_website", 
                                        language: avLang.short
                                      })
                                    }
                                  }
                                  href={`/${avLang.short.toLowerCase() != "en" ? avLang.short.toLowerCase() : ""}`}>
                                  {avLang.full}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    </ul>
                  </nav>
                  <nav className="sh__nav nav nav--main">
                    <MainNavItems
                      cssClass="desktop"
                      location="main"
                      hasActiveState={true}
                      hoveredItem={props.hoveredItem}
                      onHoverItem={item => setState(s => ({ ...s, hoveredItem: item }))}
                      onUnhoverItem={() => setState(s => ({ ...s, hoveredItem: null }))}
                    />
                  </nav>
                </div>
              </div>
              <ul className="sh__list">
                <li className="sh__item">
                  <button
                    className="sh__button search"
                    onClick={_ => {
                      setState(s => ({
                        ...s,
                        showSearchBar: !props.showSearchBar
                      }));
                      !props.showSearchBar
                        ? document.body.classList.add("noscroll")
                        : document.body.classList.remove("noscroll");
                    }}
                  >
                    <svg className="search__icon" width={20} height={20}>
                      <use xlinkHref="#icon--search" />
                    </svg>
                  </button>
                </li>
                <li className="sh__item">
                  <button
                    className="sh__toggler toggler"
                    onClick={_ => setState(s => ({ ...s, menu: props.menu == "open" ? "closed" : "open" }))}
                    aria-controls="a11y-menu"
                    aria-expanded={props.menu == "open" ? true : false}
                  >
                    <span className="sr-text">Toggle Menu</span>
                    <span className="toggler__line toggler__line--close" />
                    <span className="toggler__line toggler__line--close" />
                    <span className="toggler__line" />
                  </button>
                </li>
              </ul>
              <SearchBar
                show={props.showSearchBar}
                hide={() => {
                  setState(s => ({ ...s, showSearchBar: false }));
                }}
                searchValue={props.searchValue}
                updateSearchValue={newValue => setState(s => ({ ...s, searchValue: newValue }))}
              />
            </div>
          </div>

          {props.hoveredItem && props.hoveredItem.child_items && props.hoveredItem.child_items.length > 0 && (
            <div className="sh__flyout flyout">
              <div className="flyout__wrapper">
                <div className="flyout__inner container container--m gutter--m">
                  <div className="flyout__column flyout__column--cta">
                    {props.hoveredItem.title && <h3 className="flyout__title typo--l ff--primary">{decodeHTMLEntities(props.hoveredItem.title)}</h3>}
                    {props.hoveredItem.description && <p className="flyout__description">{props.hoveredItem.description}</p>}
                    {props.hoveredItem.button_label && (
                      <Link to={toRelativeUrl(props.hoveredItem.url)} className="flyout__button button button--primary">
                        {props.hoveredItem.button_label}
                      </Link>
                    )}
                  </div>
                  <div className="flyout__column flyout__column--menu">
                    <nav className="nav nav--submenu">
                      <ul className="nav__list">
                        {props.hoveredItem.child_items.map((menuChild: WordPress.MenuItem) => (
                          <li className="nav__item nav__item--sub" key={`main-child-${menuChild.ID}`}>
                            <Link to={toRelativeUrl(menuChild.url)} className="nav__link nav__link--sub ff--primary">
                              {decodeHTMLEntities(menuChild.title)}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Header>
      );
    }
  })

type HeaderComponentState = {
  // sticky: boolean
  // shown: boolean
}

type HeaderComponentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {

}

class Header extends React.Component<HeaderComponentProps, HeaderComponentState> {
  // private raf: number
  private headerRef: HTMLElement
  // private headerHeight: number = 0
  // private scrollStartTime: number = 0
  // private scrollStartY: number = 0

  constructor(props) {
    super(props)

    this.state = {
      // sticky: false,
      // shown: false
    };

    // this.updateScrollState = this.updateScrollState.bind(this)
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
  }

  componentWillUnmount() {
    // window.cancelAnimationFrame(this.raf)
  }

  updateScrollState(t: number) {
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
    // this.headerHeight = this.headerRef.clientHeight

    // if (window.pageYOffset < (this.headerHeight / 2)) {
    //   this.setState({
    //     ...this.state,
    //     sticky: false,
    //     shown: true
    //   })
    //   return
    // }

    // if (
    //   this.scrollStartTime > 0 &&
    //   t - this.scrollStartTime < 100 &&
    //   this.scrollStartY - window.pageYOffset > 10
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: true
    //   })
    //   return
    // } else if (
    //   this.scrollStartY - window.pageYOffset < 0 &&
    //   this.props.mobileMenu != "open"
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: false
    //   })
    // }

    // this.scrollStartY = window.pageYOffset
    // this.scrollStartTime = t

    // if (window.pageYOffset > this.headerHeight) {
    //   if (!this.state.sticky) {
    //     this.setState({
    //       ...this.state,
    //       sticky: true
    //     })
    //   }
    // } else {
    //   this.setState({
    //     ...this.state,
    //     sticky: false
    //   })
    // }
  }

  render() {
    return (
      // ${
      //   this.state.sticky ? " header--stucky" : ""
      // }${this.state.shown ? " header--showny" : ""}${
      //   this.props.mobileMenu == "open" ? " header--full-menu" : ""
      // }
      <header ref={ref => (this.headerRef = ref)} {...this.props}></header>
    )
  }
}
